export class PriceResponse {
	data: PriceModel;
	status: Status;
}

export class PriceModel {
	responseItems: PriceItem[];
}

export class Status {
	statusCode: string;
	message: string;
	priceRequestJson: string;
}

export class PriceItem {

	constructor(json: any = null) {
		if (json) {
			let priceItem = JSON.parse(json)

			this.sourceId = priceItem.sourceId;
			this.currencyCode = priceItem.currencyCode;
			this.retailCurrencyCode = priceItem.retailCurrencyCode;
			this.unitPrice = priceItem.unitPrice;
			this.retailUnitPrice = priceItem.retailUnitPrice;
			this.grossPrice = priceItem.grossPrice;
			this.netPrice = priceItem.netPrice;
			this.retailNetPrice = priceItem.retailNetPrice;
			this.quantity = priceItem.quantity;
			this.discountPct = priceItem.discountPct;
			this.axError = priceItem.axError;
			this.priceFound = priceItem.priceFound;
			this.retailPriceFound = priceItem.retailPriceFound;
			this.lookupTimestamp = priceItem.lookupTimestamp;
			this.status = priceItem.status;
			this.markupAmount = priceItem.markupAmount;
			this.markupTxt = priceItem.markupTxt;
			this.isPriceStale = this.isPriceStaleCheck();
			this.quantityNoPrice = 0;
		}
		else {
			this.quantity = 0;
			this.unitPrice = 0;
			this.grossPrice = 0;
			this.netPrice = 0;
			this.retailUnitPrice = 0;
			this.retailNetPrice = 0;
		}
	}

	sourceId: string;
	currencyCode: string;

	retailCurrencyCode: string;

	unitPrice: number;
	grossPrice: number;

	netPrice: number;

	retailUnitPrice: number;
	retailNetPrice: number;

	quantity: number;
	quantityNoPrice: number;
	discountPct: number;
	axError: boolean;
	priceFound: boolean;
	retailPriceFound: boolean;
	status: Status | undefined;
	lookupTimestamp: Date
	isDoingPriceQuery: boolean;
	isPriceStale: boolean;
	markupAmount: number;
	markupTxt: string;

	Part: string;
	PriceFound: boolean;
	CurrencyCode: string;
	RetailCurrencyCode: string;


	public isPriceStaleCheck(): boolean {
		let lastPriceLookupStaleThreshold: number = 24 * 60 * 60 * 1000; // 24 hours in miliseconds
		if (this.lookupTimestamp && (new Date(this.lookupTimestamp).getTime() + lastPriceLookupStaleThreshold < Date.now())) {
			//console.debug(`Last price lookupTimestamp was stale ${this.lookupTimestamp} => updatePrice`)
			return true;
		}
		return false;
	}

}

export class PriceModelStatus {

	constructor(statusCode: string, message: string) {
		this.statusCode = statusCode;
		this.message = message;
	}

	statusCode: string;
	message: string;
	priceRequestJson: string;

}
